fx.ns("shared.stage.base", class MediaComponent extends shared.stage.base.BaseComponent {

    constructor(component, model, parent, commands, collection, manual)
    {
        super(component, model, parent, commands, manual);

        this.collection = collection;

        this._onRenderMediaHandler = this.onMediaRendered.bind(this);
    }

    get media(){
        return this._media;
    }

    get mediaLoaded()
    {
        return this._mediaLoaded;
    }

    get temporaryImageSet()
    {
        return this._temporaryImageSet;
    }

    get isSmall()
    {
        return false;
    }

    get empty()
    {
        return (!this.media || this.media instanceof models.EmptyMedia);
    }

    get effect()
    {
        return "";
    }


    init()
    {
        super.init();

        // to avoid native drag on FF and others
        this.on("dragstart", this._dragStart);
    }

    updateMedia(content) 
    {  
        content = Utils.temporaryId(content);
        
        if (this._media)
        {
            this._media.using(false);
            this.listenUpdates( this._media, false );
        }
            

        this._listenMedia(false);
        this._media = this.collection.find({ id : content });

        if (!this._media)
        {
            this._media = this.collection.emptyMedia;//new models.EmptyMedia( this.data );
            //this._media = new models.EmptyMedia( this.data );
        }
        else
        {
            this._media.using(true);
            this.listenUpdates( this._media, true );
        }   
        

        if (!this._media || this._media.isLoaded(this.effect))
        {
            this.complete();
            //this.renderMedia();
        }
        else
        {
            this._listenMedia(true);
            
            //this._media.load(this.effect, this.isSmall);
            fx.medialoader.load( this._media, this.effect, this.isSmall );
        }

        this._mediaLoaded = true;
    }

    onDelete() 
    {
        super.onDelete();
        
        if (this.media)
            this.media.using(false);
    }

     /**
     * TO OVERRIDE
     */
    //renderMedia(rotation)
    renderMedia()
	{
        //this.media.fetch(rotation, this._onRenderMediaHandler, this.effect);
        if (this.media)
            return this.media.fetch(this._onRenderMediaHandler, this.effect);
        else
            this.image.data = "";
    }
    
    onMediaRendered( rendered )
    {
        if (rendered.media != this.media)
            return;

        if(this.image.data != rendered.url)
        {
            if (!this._temporaryImageSet)
                this.on("complete", this._onComplete, this.image);
                
            this.image.data = rendered.url;
        }
    }

    _onComplete()
    {
        this.data.event("media-loaded", null, 500);
    }

     //-- Image Loading events
     start(e) 
     { 
         if (!this.SVGElement)
             return;
 
         if (!this._temporaryImageSet && fx.get("app") != "screenshot")
         {
            this._temporaryImageSet = true;
            this.onMediaRendered({url : this.media.getThumb(this.effect) /*this.media.thumb*/, width : this.media.width, height : this.media.height, media: this.media});
         }
     }

     /*loading()
     {
         this.start();
     }*/
 
     /*progress(e)
     { 
         
     }*/
 
     complete()
     {
        this._temporaryImageSet = false;
        
        this._listenMedia(false);

        // nothing was rendered : the media cache was emptied in between (clean/unload).
        // the load must not be reported as successful, that would cancel a pending retry.
        if (this.renderMedia() === false)
            return;

        this._handleErrorLoading(false);
     }
 
     error()
     {
        this._listenMedia(false);
        this._handleErrorLoading(true);
     }
 
     
     // -------- 
 
     _listenMedia(val)
     {
         if (!this._media) return;
 
         if (val && !this._listening)
         {
             this.on("start", this.start, this.media);
             this.on("loading", this.start, this.media);
             //this.on("progress", this.progress, this.media);
             this.on("complete", this.complete, this.media);
             this.on("error", this.error, this.media);
         }
 
         else
         if (!val && this._listening)
         {
             this.off("start", this.start, this.media);
             this.off("loading", this.start, this.media);
             //this.off("progress", this.progress, this.media);
             this.off("complete", this.complete, this.media);
             this.off("error", this.error, this.media);
         }
 
         this._listening = val;
     }

         /**
     * Disable native drag behaviour
     */
    _dragStart(e) 
    {
		e.preventDefault();
		return false;
    }


    
    _handleErrorLoading(error)
    {
        if (error !== undefined)
            this._errorLoading = error;

        if (this._updateMediaAgainTimer)
            //clearTimeout(this._updateMediaAgainTimer);
            this.delay(this._updateMediaAgainTimer, null);

        if (this._errorLoading)
        {    
            /*if (!this._errorText)
            {
                this._errorBackground = this.SVGElement.circle(30, 30).fill('rgba(255,255,255,0.9)');
                this._errorText = this.SVGElement.text("!")
                                                .attr("class", "error")
                                                .attr("font-size","1.8em")
                                                .fill("red");

                this._errorWarning = this.SVGElement.element('title')
                                                    .words("Cette image n'a pu être chargée");
            }

            let bbox = this._errorText.node.getBBox();
            
            this._errorText.scale(1/this.parent.scale);
            this._errorText.translate( (this.width - bbox.width/this.parent.scale) / 2 - bbox.x/this.parent.scale,  (this.height - bbox.height/this.parent.scale) / 2 - bbox.y/this.parent.scale);

            this._errorBackground.move((this.width - 30) / 2 ,  (this.height - 30) / 2 );*/
            
            if (!this._updateMediaAgainCount)
                this._updateMediaAgainCount = 1;

            if (this._updateMediaAgainCount < 5)
                this._updateMediaAgainTimer = this.delay(this._updateMediaAgain, 2000);
        }
        else
        {
            /*if (this._errorText)
            {
                this._errorText.remove();
                this._errorBackground.remove();
                this._errorWarning.remove();
            }*/

            this._updateMediaAgainCount = 0;
        }
    }
    
    _updateMediaAgain() 
    {
        this._updateMediaAgainTimer = null;
        this._updateMediaAgainCount++;

        if (this._media)
            this.updateMedia( this._media.id );
    }

    destroy()
    {
        super.destroy();

        if (this._media)
            fx.medialoader.stop( this._media, this.effect );

        if (this._updateMediaAgainTimer)
            this.delay(this._updateMediaAgainTimer, null);
    }

});